import React from 'react';
export const ProductSection: React.FC = () => {
  return <section className="bg-[#F5F5EB] py-20 px-5 text-center" data-id="element-209">
      <div className="inline-block bg-gradient-to-br from-brown-mid to-brown-light text-white py-[7px] px-[22px] rounded-full text-xs font-sans font-bold tracking-[2px] uppercase mb-[15px]" data-id="element-210">
        🏗️ MEGA PACK TIERRA VIVA™
      </div>
      <h2 className="text-[clamp(24px,4vw,42px)] text-[#1A1A1A] mb-2 leading-[1.2]" data-id="element-211">
        3 Tomos + 4 Bonos — Del Suelo a la Llave
      </h2>
      <p className="text-base text-[#777] font-sans mb-[35px]" data-id="element-212">
        150 páginas técnicas. Todo resuelto. Sin buscar. Sin improvisar. Sin
        perder domingos.
      </p>

      <div className="flex justify-center flex-wrap gap-2 mb-[30px]" data-id="element-213">
        <span className="py-2 px-5 rounded-full text-[13px] font-sans font-bold cursor-pointer border-2 border-transparent transition-all duration-200 bg-brown-mid text-white" data-id="element-214">
          📗 Tomo 1
        </span>
        <span className="py-2 px-5 rounded-full text-[13px] font-sans font-bold cursor-pointer border-2 border-transparent transition-all duration-200 bg-green-mid text-white" data-id="element-215">
          📘 Tomo 2
        </span>
        <span className="py-2 px-5 rounded-full text-[13px] font-sans font-bold cursor-pointer border-2 border-transparent transition-all duration-200 bg-brown-dark text-white" data-id="element-216">
          📙 Tomo 3
        </span>
        <span className="py-2 px-5 rounded-full text-[13px] font-sans font-bold cursor-pointer border-2 border-brown-mid transition-all duration-200 bg-brown-mid/15 text-brown-mid" data-id="element-217">
          🎁 4 Bonos
        </span>
      </div>

      <div className="grid grid-cols-[repeat(auto-fit,minmax(290px,1fr))] gap-[25px] max-w-[1050px] mx-auto mb-10" data-id="element-218">
        {/* Tomo 1 */}
        <div className="rounded-2xl overflow-hidden shadow-[0_8px_35px_rgba(0,0,0,0.10)] bg-white transition-transform duration-300 hover:-translate-y-1.5 text-left" data-id="element-219">
          <div className="py-7 px-6 pb-5 text-white bg-gradient-to-br from-[#7A3B10] to-[#A0522D]" data-id="element-220">
            <div className="text-[11px] font-sans font-bold tracking-[3px] uppercase opacity-75 mb-1.5" data-id="element-221">
              📗 TOMO 1 — 50 PÁGINAS
            </div>
            <h3 className="text-xl mb-1.5 leading-[1.2]" data-id="element-222">
              La Ciencia del Suelo · Base Constructiva
            </h3>
            <p className="text-[13px] opacity-85 font-sans leading-[1.4]" data-id="element-223">
              El ADN de tu casa. Antes de poner la primera piedra, dominá tu
              material.
            </p>
          </div>
          <div className="py-[22px] px-6" data-id="element-224">
            <ul className="list-none p-0" data-id="element-225">
              {['Test del Frasco: Tu laboratorio de campo en 24h', 'Cómo leer y corregir tu tierra arcillosa', 'Inercia térmica vs. aislamiento: cuál necesitás', 'Orientación solar: calefacción de $0', 'Prueba de la cinta y la bola (plasticidad)', 'Plan de acción días 1 al 28'].map((item, i) => <li key={i} className="py-2 text-sm font-sans text-[#444] border-b border-[#F5F5F0] flex items-start gap-[9px] leading-[1.4] last:border-b-0" data-id="element-226">
                  <span className="shrink-0 text-[13px]" data-id="element-227">✅</span> {item}
                </li>)}
            </ul>
          </div>
          <div className="px-6 pb-[22px] flex justify-between items-center" data-id="element-228">
            <span className="bg-[#F5F0E8] text-brown-mid py-1 px-3.5 rounded-full text-xs font-sans font-bold" data-id="element-229">
              📄 50 Páginas Técnicas
            </span>
          </div>
        </div>

        {/* Tomo 2 */}
        <div className="rounded-2xl overflow-hidden shadow-[0_8px_35px_rgba(0,0,0,0.10)] bg-white transition-transform duration-300 hover:-translate-y-1.5 text-left" data-id="element-230">
          <div className="py-7 px-6 pb-5 text-white bg-gradient-to-br from-[#244D1E] to-[#2D5A27]" data-id="element-231">
            <div className="text-[11px] font-sans font-bold tracking-[3px] uppercase opacity-75 mb-1.5" data-id="element-232">
              📘 TOMO 2 — 50 PÁGINAS
            </div>
            <h3 className="text-xl mb-1.5 leading-[1.2]" data-id="element-233">
              Ingeniería Estructural · Del Cimiento al Techo
            </h3>
            <p className="text-[13px] opacity-85 font-sans leading-[1.4]" data-id="element-234">
              Levantá una estructura que dure 300 años y baile con los sismos
              sin romperse.
            </p>
          </div>
          <div className="py-[22px] px-6" data-id="element-235">
            <ul className="list-none p-0" data-id="element-236">
              {['Cimientos de piedra y cal: Las "botas" perfectas', 'Adobe y BTC: El ladrillo que respira', 'Quincha y Bahareque: Sistema antisísmico', 'Vigas corona: El cinturón de tu estructura', 'Colocación de marcos y pre-armados', 'Plan de obra días 29 al 56'].map((item, i) => <li key={i} className="py-2 text-sm font-sans text-[#444] border-b border-[#F5F5F0] flex items-start gap-[9px] leading-[1.4] last:border-b-0" data-id="element-237">
                  <span className="shrink-0 text-[13px]" data-id="element-238">✅</span> {item}
                </li>)}
            </ul>
          </div>
          <div className="px-6 pb-[22px] flex justify-between items-center" data-id="element-239">
            <span className="bg-[#F5F0E8] text-brown-mid py-1 px-3.5 rounded-full text-xs font-sans font-bold" data-id="element-240">
              📄 50 Páginas Técnicas
            </span>
          </div>
        </div>

        {/* Tomo 3 */}
        <div className="rounded-2xl overflow-hidden shadow-[0_8px_35px_rgba(0,0,0,0.10)] bg-white transition-transform duration-300 hover:-translate-y-1.5 text-left" data-id="element-241">
          <div className="py-7 px-6 pb-5 text-white bg-gradient-to-br from-[#4A3A28] to-[#6B5540]" data-id="element-242">
            <div className="text-[11px] font-sans font-bold tracking-[3px] uppercase opacity-75 mb-1.5" data-id="element-243">
              📙 TOMO 3 — 50 PÁGINAS
            </div>
            <h3 className="text-xl mb-1.5 leading-[1.2]" data-id="element-244">
              Acabados de Lujo · La Piel de tu Casa
            </h3>
            <p className="text-[13px] opacity-85 font-sans leading-[1.4]" data-id="element-245">
              Transforma el barro en una vivienda premium que parece salida de
              una revista.
            </p>
          </div>
          <div className="py-[22px] px-6" data-id="element-246">
            <ul className="list-none p-0" data-id="element-247">
              {['Revoques de cal hidráulica: El escudo impermeable', 'Técnica del Bruñido con piedra de río', 'Tadelakt Marroquí: Impermeabilización milenaria', 'Suelos de tierra con aceite de linaza y cera', 'Pinturas naturales con pigmentos minerales', 'Plan de terminación días 57 al 90'].map((item, i) => <li key={i} className="py-2 text-sm font-sans text-[#444] border-b border-[#F5F5F0] flex items-start gap-[9px] leading-[1.4] last:border-b-0" data-id="element-248">
                  <span className="shrink-0 text-[13px]" data-id="element-249">✅</span> {item}
                </li>)}
            </ul>
          </div>
          <div className="px-6 pb-[22px] flex justify-between items-center" data-id="element-250">
            <span className="bg-[#F5F0E8] text-brown-mid py-1 px-3.5 rounded-full text-xs font-sans font-bold" data-id="element-251">
              📄 50 Páginas Técnicas
            </span>
          </div>
        </div>
      </div>

      <div className="bg-gradient-to-br from-green-brand to-green-dark rounded-2xl py-[35px] px-10 max-w-[800px] mx-auto text-left md:px-[22px] md:py-[25px]" data-id="element-252">
        <h3 className="text-gold-main text-lg font-sans font-bold mb-5 text-center" data-id="element-253">
          ✅ Cada Tomo Incluye:
        </h3>
        <div className="grid grid-cols-[repeat(auto-fit,minmax(220px,1fr))] gap-3" data-id="element-254">
          {['Plan de acción diario listo', 'Proporciones exactas de mezcla', 'Técnicas paso a paso con medidas', 'Diagnóstico y solución de patologías', 'Errores comunes y cómo evitarlos', 'Adaptación a climas fríos, cálidos y húmedos', '100% aplicable en Argentina y Latinoamérica', 'Alineado a normativas vigentes de bioconstrucción'].map((item, i) => <div key={i} className="flex items-center gap-2.5 text-sm font-sans text-[#C8E6C9]" data-id="element-255">
              <span className="shrink-0 text-sm" data-id="element-256">✅</span> {item}
            </div>)}
        </div>
      </div>
    </section>;
};